import { Injectable } from '@angular/core';

import { ApiService, CustomerAreaService, CustomerSectorService } from '@app/services';
import { StoreDirectory, StoreDashboard } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

    static Stores: Array<StoreDirectory> = [];
    static MapStoresAreas: Map<number, number> = new Map();
    static MapStoresSectors: Map<number, number> = new Map();

    constructor(
        private apiService: ApiService
    ) {}

    reset(){  
        StoreService.Stores = [];
        StoreService.MapStoresAreas = new Map();
        StoreService.MapStoresSectors = new Map();
    }

    /*
    async loadStoreDirectory(): Promise<StoreDirectory[]> {
        let storeDirectory: Array<StoreDirectory> = [];
        let response = await this.apiService.get('order/store-directory');
        if(response?.data?.stores){
            storeDirectory = response.data.stores;
        }
        return storeDirectory;
    }
    */
    
    async loadStoreDirectory(): Promise<StoreDirectory[]> {        
        let storeDirectory: Array<StoreDirectory> = [];                
        let response = await this.apiService.get('order/store-directory');
        if(response?.data?.stores){
            for(let store of response.data.stores){
                let areaId = StoreService.MapStoresAreas.get(store.id);
                let sectorId = StoreService.MapStoresSectors.get(store.id);
                if(areaId && sectorId){
                    store.customerArea = areaId;
                    store.customerSector = sectorId;
                    storeDirectory.push(store);
                }
            }
        }     
        storeDirectory.sort((a, b) => a.name.localeCompare(b.name));   
        return storeDirectory;
    }
    
    async loadStoreDashboard(storeId: number, year?: number, month?: number, operation?: number): Promise<StoreDashboard|null> {
        let storeDashboard: StoreDashboard|null = null; 
        let params: any = {};
        if(year){
            params.year = year.toString();
        }       
        if(month){
            params.month = month.toString();
        }       
        if(operation){
            params.operation = operation.toString();
        }       
        let response = await this.apiService.get('order/store/' + storeId + '/dashboard/with-kpi', params);
        if(response?.data){
            storeDashboard = response.data;
            if(storeDashboard){
                let idArea = StoreService.MapStoresAreas.get(storeDashboard.store.id);
                let area = (idArea ? CustomerAreaService.Areas.find(a => a.id === idArea) : undefined);
                if(area){
                    storeDashboard.store.customerAreaId = area.id;
                    storeDashboard.store.customerAreaName = area.name;
                }
                let idSector = StoreService.MapStoresSectors.get(storeDashboard.store.id);
                let sector = (idSector ? CustomerSectorService.Sectors.find(a => a.id === idSector) : undefined);
                if(sector){
                    storeDashboard.store.customerSectorId = sector.id;
                    storeDashboard.store.customersectorName = sector.name;
                }
            }
        }
        return storeDashboard;        
    }
    
    async findCustomerSector(operationId: number, storeId: number): Promise<number|null> {
        let customerSectorId: number|null = null;
        let params = {
            operation: operationId,
            store: storeId
        };
        let response = await this.apiService.get('order/customer-sector-id', params);
        if(response?.data){
            customerSectorId = response.data;
        }
        return customerSectorId;
    }
    
    async loadAdditionalsDatas(operationId: number, storeId: number): Promise<any>{
        let data: any = null;        
        let response = await this.apiService.get('order/operation/'+operationId+'/store/'+storeId+'/customer-directions-questionnaire');
        if(response?.data?.lastDirectionsPayloadForStore){
            data = JSON.parse(response.data.lastDirectionsPayloadForStore);
        }
        return data;
    }
    
    async saveAdditionalsDatas(operationId: number, storeId: number, data: any): Promise<boolean>{       
        let body: any = {
            payload: JSON.stringify(data)
        };
        let response = await this.apiService.post('order/operation/'+operationId+'/store/'+storeId+'/customer-directions-questionnaire', body);
        return (response.error === null);
    }
}
